import { Component, OnInit, Inject } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';

@Component({
    selector: 'side-effect-organization',
    templateUrl: './side-effect-organization.component.html',
    styleUrls: ['./side-effect-organization.component.scss'],
    standalone: false
})
export class SideEffectOrganizationComponent implements OnInit {

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
    }

    ngOnInit() {
    }

}
